module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/pic_1.8c66ec1e-f45d7b2b9f6cd4139ca7b282367677df.png";